const PROFILE_EDITOR_ROLES = ['institutional-marketing-only-staff', 'institutional-admin', 'institutional-staff'];

export const canUserEditMarketingProfile = (userRoles: string[]): boolean => PROFILE_EDITOR_ROLES.reduce((acc, role) => acc || userRoles.includes(role), false);
export const isMarketingOnlySchoolUser = (userRoles: string[]): boolean => userRoles.includes('institutional-marketing-only-staff');
